import { Divider } from "antd";
import TextBox from "components/Form/TextBox/TextBox";
import { config } from "consts/api";
import { isEmail, required } from "modules/validations";
import PropTypes from "prop-types";
import React from "react";
import Recaptcha from "react-recaptcha";
import { I18n } from "react-redux-i18n";
import { getUserSuits, handleLogin } from "reducers/user";
import { Field, reduxForm } from "redux-form";
import { RoutedComponent, connect } from "routes/routedComponent";
import logo from "static/logos/appgain-new-slogan.svg";
import templateLogin from "static/template-slider-login.png";
import PrimaryButton from "../../../components/Form/Buttons/PrimaryButton/PrimaryButton";
import { Toast } from "../../../modules/toast";
import Carousel from "../Slider";
import classes from "./Login.scss";

class LoginContainer extends RoutedComponent {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  state = {
    recaptcha: "",
    loadedRecaptcha: false,
    loader: false,
  };

  onloadRecaptcha = () => {
    this.setState({ loadedRecaptcha: true, recaptcha: "" });
  };

  handleRecaptcha = (recaptcha) => {
    this.setState({ recaptcha });
  };

  handleExpiredRecaptcha = () => {
    this.setState({ recaptcha: false });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { form, handleLogin } = this.props;
    const { recaptcha } = this.state;

    try {
      this.setState({ loader: true });
      await handleLogin({ ...form.login.values, recaptcha });

      Toast.success(`Welcome To Appgain 👋`);
      this.context.router.push("/home");
    } catch (e) {
      Toast.error(e?.response?.body?.message);
    } finally {
      this.setState({ loader: false });
    }
  };

  render() {
    const { recaptcha, loader } = this.state;

    const { valid } = this.props;

    const isProductionOrDevops = [
      config.MODE_ENUM.PRODUCTION,
      config.MODE_ENUM.DEVOPS,
    ].includes(config.MODE);

    const isRecaptchaInvalid = recaptcha === "" || !recaptcha;

    const isDisabled =
      !valid || loader || (isProductionOrDevops && isRecaptchaInvalid);

    return (
      <div className={classes["login__page"]}>
        <div className={classes["login__form"]}>
          {this.state.loader && (
            <div className={classes["loader"]}>
              <i className="fa fa-spinner" aria-hidden="true" />
            </div>
          )}
          <form onSubmit={this.handleSubmit} className={classes.formContainer}>
            <div className={classes["form-header"]}>
              <div className={classes["appgain-logo"]}>
                <img src={logo} />
              </div>
              <h1 className={classes.pageTitle}>{I18n.t("authPagesTitle")}</h1>
            </div>
            <div className={classes["input-form"]}>
              <Field
                name="email"
                component={TextBox}
                placeholder={I18n.t("EmailAddress")}
                animationClassName={classes["field__moveInRight"]}
                validate={[required, isEmail]}
              />
            </div>
            <div className={classes["input-form-password"]}>
              <Field
                name="password"
                component={TextBox}
                rightClickableHint={I18n.t("loginPage_ForgotPassword")}
                onRightClickableHint={() => {
                  !this.state.loader &&
                    this.context.router.push("/auth/forgot");
                }}
                disabledRightClick={this.state.loader}
                placeholder={I18n.t("password")}
                type="password"
                animationClassName={classes["field__moveInLeft"]}
                validate={required}
              />
            </div>
            <div className={classes.recaptcha}>
              {(config.MODE === config.MODE_ENUM.PRODUCTION ||
                config.MODE === config.MODE_ENUM.DEVOPS) &&
                !this.state.loader && (
                  <Recaptcha
                    sitekey="6LcWBRIUAAAAABFttXLEOhwchPmupy4022EOUOzC"
                    render="explicit"
                    verifyCallback={this.handleRecaptcha}
                    className="google-recaptcha"
                    onloadCallback={this.onloadRecaptcha}
                  />
                )}
            </div>
            <div className={classes["login-btn"]}>
              <PrimaryButton disabled={isDisabled} block type="submit">
                {I18n.t("loginBtn")}
              </PrimaryButton>
            </div>

            <Divider>{I18n.t("or")}</Divider>

            <div className={classes.signUp}>
              <p>
                {I18n.t("loginPage_ques")}
                <a
                  href={config.REQUEST_DEMO}
                  target="_top"
                  className={classes.requestDemoLink}
                >
                  {I18n.t("loginPage_requestDemo")}
                </a>
              </p>
            </div>
          </form>
        </div>
        <div className={`col-md-hidden ${classes["slider"]}`}>
          <Carousel image={templateLogin} />
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: "login",
})(
  connect(
    (store) => ({
      user: store.user,
      form: store.form,
    }),
    {
      handleLogin,
      getUserSuits,
    }
  )(LoginContainer)
);
